function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect } from "react";
import styled from "styled-components";
import { formatToReact } from "sprout-lib/dist/parser";
import { parse as parseQueryString } from "query-string";
import { useActionRegistryGlobalHandler } from "@sprout/list-navigation";
import { useHistory, useLocation } from "react-router-dom";
import { Button } from "sprout-ui-dom/dist/Button";
import { DescriptionPopoverDialog } from "@sprout/client-components/dist/PopoverDialog";
import { usePopoverDialogState } from "sprout-ui-dom/dist/PopoverDialog";
import { PopoverReference, PopoverTrigger } from "sprout-ui-dom/dist/Popover";
import { media } from "sprout-ui-theme";
import { Box } from "sprout-ui-primitives";
import { usePostPage } from "../PostPageContext";
const PostDescriptionWrapper = styled(Box)`
  line-height: 34px;
  font-size: 34px;

  ${media.up("medium")} {
    line-height: 45px;
    font-size: 45px;
  }
`;
const PostPageDescriptionEditorWrapper = styled("div")`
  text-align: center;
  label {
    vertical-align: top;
    margin-right: 16px;
  }
`;
const PostPageDescriptionEditorButton = styled(Button)`
  ${media.up("medium")} {
    margin-top: 5px;
  }
`;
const PostPageDescriptionEditor = (props)=>{
    const { itemId , description , disabled: disabledProp , children  } = props;
    const { disabled  } = usePostPage();
    const readOnly = disabled || disabledProp;
    const isEmptyDescription = !description;
    const popoverDialogState = usePopoverDialogState();
    //
    const { onOpenChange  } = popoverDialogState;
    useActionRegistryGlobalHandler("PAGE_FOCUS_DESCRIPTION", useCallback(()=>{
        onOpenChange(true);
        return true;
    }, [
        onOpenChange
    ]), {
        skip: readOnly,
        preventDefault: true
    });
    const { state , pathname , search  } = useLocation();
    const { f  } = parseQueryString(search);
    const history = useHistory();
    useEffect(()=>{
        if (state && state.focusDescriptionEditor || f === "d") {
            onOpenChange(true);
            history.replace(pathname);
        }
    }, [
        f,
        history,
        onOpenChange,
        pathname,
        state
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(DescriptionPopoverDialog, _objectSpread({
                description: description,
                itemId: itemId
            }, popoverDialogState)),
            /*#__PURE__*/ _jsx(PopoverReference, _objectSpread({}, popoverDialogState, {
                children: /*#__PURE__*/ _jsxs(PostPageDescriptionEditorWrapper, {
                    children: [
                        children,
                        /*#__PURE__*/ _jsx(PopoverTrigger, _objectSpread({}, popoverDialogState, {
                            disabled: readOnly,
                            children: isEmptyDescription && !disabled ? /*#__PURE__*/ _jsx(PostPageDescriptionEditorButton, {
                                variant: "bright-teal",
                                children: "Add description"
                            }) : /*#__PURE__*/ _jsx(PostDescriptionWrapper, {
                                display: "inline",
                                color: !description ? "black.24" : "black.87",
                                children: formatToReact(description || "No description", "BASIC")
                            })
                        }))
                    ]
                })
            }))
        ]
    });
};
export default PostPageDescriptionEditor;
